import { useEffect } from 'react'
import { isApiConfigured } from '@/config/api/env'
import { fetchThreadDetail, fetchThreadRuns } from '@/services/chat/threadsApi'
import { applyFetchedThreadMessages } from './backendChatSyncState'

export function useBackendThreadMessagesSync(m, accessToken) {
  const { displayThreadId, setMessagesByThreadId } = m

  useEffect(() => {
    if (!accessToken || !isApiConfigured() || !displayThreadId) return
    const controller = new AbortController()
    const sync = () => {
      void Promise.all([
        fetchThreadDetail(displayThreadId, { signal: controller.signal }),
        fetchThreadRuns(displayThreadId, { activeOnly: true, signal: controller.signal }),
      ])
        .then(([detail, runs]) => {
          setMessagesByThreadId((prev) =>
            applyFetchedThreadMessages(prev, displayThreadId, detail, runs),
          )
        })
        .catch(() => {})
    }
    sync()
    const interval = window.setInterval(sync, 2500)
    return () => {
      window.clearInterval(interval)
      controller.abort()
    }
  }, [accessToken, displayThreadId, setMessagesByThreadId])
}
